import { ReducerService } from "../../../services/reducer";
import { reducer } from "./api/reducer";

export const init = () => {
  ReducerService.set("snackbar", reducer);
};
